import { render, staticRenderFns } from "./EmptyChatList.vue?vue&type=template&id=7d06546c"
import script from "./EmptyChatList.vue?vue&type=script&lang=js"
export * from "./EmptyChatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports